<template>
  <v-col>
    <!--Sale Refund data table -->
    <refunds-table
      :key="index"
      text-color="red"
      url-api="/order?filter=refunding"
      :headers="headers"
    >
      <!-- Return transaction -->
      <template v-slot:refrence="{ item }">
        <div class="white pa-1">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-img
                v-bind="attrs"
                :src="item.barcode"
                lazy-src="/storage/default_img/no_image.png"
                aspect-ratio="1"
                max-width="100"
                max-height="15"
                v-on="on"
              />
            </template>
            <span>TRX #{{ item.key }}</span>
          </v-tooltip>
        </div>
      </template>
      <!-- end -->

      <!-- Return method -->
      <template v-slot:method="{ item }">
        {{ item.method ? "Live" : "Due" }}
      </template>
      <!-- end -->

      <!-- Sold QTY -->
      <template v-slot:qty="{ item }">
        {{ item.totalItems }}
      </template>
      <!-- end -->

      <!-- Return Sub total -->
      <template v-slot:subTotal="{ item }">
        {{ item.subTotal | currency }}
      </template>
      <!-- end -->

      <!-- Return or reverted cost -->
      <template v-slot:cost="{ item }">
        {{ item.cost | currency }}
      </template>
      <!-- end -->

      <!-- Return Profit -->
      <template v-slot:profit="{ item }">
        {{ item.profit | currency }}
      </template>
      <!-- end -->

      <!-- Total Amount -->
      <template v-slot:totalAmount="{ item }">
        {{ item.totalAmount | currency }}
      </template>
      <!-- end -->

      <!-- ColumnActions -->
      <template v-slot:columnaction="{ item }">
        <!-- Return details -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'RefundDetail',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-more
              </v-icon>
            </v-btn>
          </template>
          <span>More details</span>
        </v-tooltip>
        <!-- end -->

        <!-- Sale return Print -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'PrintRefund',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-printer
              </v-icon>
            </v-btn>
          </template>
          <span>Print</span>
        </v-tooltip>
        <!-- end -->

        <!-- Refund sale remove -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              icon
              @click="warningRefundRemove(item)"
              v-on="on"
            >
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
        <!-- end -->
      </template>
      <!-- end columnActions -->
    </refunds-table>

    <!-- end data table -->

    <!-- Sale order remove warning -->
    <v-dialog
      v-model="refundRemoveWarning"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Warning: Are you sure to remove ?
        </v-card-title>
        <v-card-text>
          Note: Returned item quantity has been updated will not be reverse.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="refundRemoveWarning = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error darken-1"
            text
            @click="removeRefund"
          >
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end -->
  </v-col>
</template>

<script>
import SaleReturnsTable from "../common/DataTable.vue";
import { mapActions } from "vuex";

export default {
  components: {
    "refunds-table": SaleReturnsTable,
  },
  data() {
    return {
      refundRemoveWarning: false,
      refund: [],
      index: 1,
      headers: [
        {
          text: "Created At",
          align: "start",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Trx ID",
          sortable: true,
          value: "refrence",
          slot: "refrence",
        },
        {
          text: "Returned items",
          sortable: true,
          value: "totalItems",
          slot: "qty",
        },

        {
          text: "Reverted Profit",
          sortable: true,
          value: "profit",
          slot: "profit",
        },

        {
          text: "Refund Amount",
          sortable: true,
          value: "totalAmount",
          slot: "totalAmount",
        },

        {
          text: "Actions",
          sortable: false,
          slot: "columnaction",
        },
      ],
    };
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    removeRefund() {
      window.axios.delete("/order/" + this.$data.refund.id).then((response) => {
        this.$data.refundRemoveWarning = false;
        this.$data.index++;
        this.feedback(response.data.message);
      });
    },
    warningRefundRemove(refund) {
      this.$data.refund = refund;
      this.$data.refundRemoveWarning = true;
    },
  },
};
</script>
